import {MenuItem} from "./menu-item";

export class Menu {
    name: string;
    position: string = 'header';
    items: MenuItem[] = [];

    constructor(params: Object = {}) {
        for (let name in params) {
            this[name] = params[name];
        }

        if (Array.isArray(this.items)) {
            this.items = this.items.map(item => new MenuItem(item));
        }
    }
}


// WEBPACK FOOTER //
// /mnt/e/apps/helpdesk/client/src/app/admin/appearance/menus/menu.ts